/// <amd-module name="Pipeline/Analytics/Common/Telemetry/PipelineAnalyticsTelemetryService" />
import { ContextType, IReportContext } from "Analytics/Shared/Common/Types";
import * as Telemetry from "Analytics/Shared/Common/Utils/Telemetry";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IPipelineAnalyticsTelemetryService extends IVssService {
    initialize(definitionId: number): void;
    publishEvent(feature: string, properties: { [key: string]: any }): void;
    publishEventWithSingleKey(feature: string, key: string, value: any): void;
}

class PipelineAnalyticsTelemetryService extends VssService implements IPipelineAnalyticsTelemetryService {
    private static area: string = TelemetryConstants.area;

    private _pageContext: IVssPageContext;
    private _definitionId: number;

    public initialize(definitionId: number): void {
        this._definitionId = definitionId;
    }

    public publishEvent(feature: string, properties: { [key: string]: any }): void {
        const reportContext = {
            contextType: ContextType.Build,
            definitionId: this._definitionId
        } as IReportContext;

        Telemetry.publishEvent(this._pageContext, PipelineAnalyticsTelemetryService.area, feature, reportContext, properties);
    }

    public publishEventWithSingleKey(feature: string, key: string, value: any): void {
        const properties: { [key: string]: any } = {};
        properties[key] = value;
        this.publishEvent(feature, properties);
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        this._pageContext = pageContext;
        super._serviceStart(pageContext);
    }
}

Services.add("IPipelineAnalyticsTelemetryService", { serviceFactory: PipelineAnalyticsTelemetryService });
